var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_1247)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.25C11.4645 16.25 10.625 15.4105 10.625 14.375C10.625 13.3395 11.4645 12.5 12.5 12.5C13.5355 12.5 14.375 13.3395 14.375 14.375C14.375 15.4105 13.5355 16.25 12.5 16.25ZM12.5 10C11.4645 10 10.625 9.16055 10.625 8.125C10.625 7.08945 11.4645 6.25 12.5 6.25C13.5355 6.25 14.375 7.08945 14.375 8.125C14.375 9.16055 13.5355 10 12.5 10ZM12.5 3.75C11.4645 3.75 10.625 2.91055 10.625 1.875C10.625 0.839453 11.4645 0 12.5 0C13.5355 0 14.375 0.839453 14.375 1.875C14.375 2.91055 13.5355 3.75 12.5 3.75ZM7.50001 20C6.46447 20 5.62501 19.1605 5.62501 18.125C5.62501 17.0895 6.46447 16.25 7.50001 16.25C8.53556 16.25 9.37501 17.0895 9.37501 18.125C9.37501 19.1605 8.53556 20 7.50001 20ZM7.50001 13.75C6.46447 13.75 5.62501 12.9105 5.62501 11.875C5.62501 10.8395 6.46447 10 7.50001 10C8.53556 10 9.37501 10.8395 9.37501 11.875C9.37501 12.9105 8.53556 13.75 7.50001 13.75ZM7.50001 7.5C6.46447 7.5 5.62501 6.66055 5.62501 5.625C5.62501 4.58945 6.46447 3.75 7.50001 3.75C8.53556 3.75 9.37501 4.58945 9.37501 5.625C9.37501 6.66055 8.53556 7.5 7.50001 7.5Z",
    fill: "#6B7280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_1247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 20) rotate(-180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.a7a36713f1259748908ee8e988e1a2c3.svg";
export { ForwardRef as ReactComponent };